import { Box } from "@mui/material"
import {
  FocusContext,
  useFocusable,
} from "@noriginmedia/norigin-spatial-navigation"
import React, { memo } from "react"

import { Slider, TTeaser } from "../../../components/Sliders/Slider"
import { MyStageSliders } from "../../../hooks/use-mystage-screen"
import { useSmoothNavigate } from "../../../hooks/use-smooth-navigate"
import { ArrayElement } from "../../../types"
import { s } from "../../../utilities/common"
import { AddFocusFunction } from "../../../utilities/use-focus-helper"

import { EmptyState } from "./EmptyState"

export const MyStageSlider = memo(
  ({
    slider,
    index,
    hasMargin,
    addFocus,
  }: {
    slider: ArrayElement<MyStageSliders>
    index: number
    hasMargin: boolean
    addFocus: AddFocusFunction
  }) => {
    const navigate = useSmoothNavigate()
    const { ref, focusKey } = useFocusable({
      focusKey: "MyStageSlider" + index,
    })
    return (
      <FocusContext.Provider value={focusKey}>
        <Box ref={ref} sx={{ mt: "1px" }}>
          {slider ? (
            <Slider
              onPressBrowse={() => {
                addFocus({ forceKey: focusKey })
                navigate(`browse/0/${slider.id}/1/0`)
              }}
              onPressTitle={(d?: TTeaser, teaserIndex?: number) => {
                if (!d || teaserIndex === undefined) return
                addFocus({ forceKey: focusKey })
                navigate(
                  `detail/${d.type}/${d.id}/${index + 1}/${teaserIndex + 1}/${
                    slider.id
                  }`,
                )
              }}
              onFocus={({ top: y }, _, query) => {
                if (!(query && query.noScroll)) {
                  document.getElementById("root")!.style.transform =
                    "translate3d(0, " + Math.min(0, -y + s(300)) + "px, 0)"
                }
              }}
              title={slider.title}
              data={slider}
              dimensions={slider.style}
              margin={hasMargin}
              prefix={"MyStage"}
            />
          ) : (
            <EmptyState key={"MyStageSlider" + index} index={index} />
          )}
        </Box>
      </FocusContext.Provider>
    )
  },
  (prevProps, nextProps) => {
    // check if presented sliders are the same after myStage update
    return (
      prevProps.slider?.teasers
        ?.map((teaser) => teaser.id + teaser.progress)
        .join(", ") ===
        nextProps.slider?.teasers
          ?.map((teaser) => teaser.id + teaser.progress)
          .join(", ") &&
      prevProps.slider?.pageInfo?.hasNextPage ===
        nextProps.slider?.pageInfo?.hasNextPage
    )
  },
)
